(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fenno-ring-decision"] && !Shopify.designMode) return;
  try {
    function fennoSyncStickyHeight(){
  if(!document.body.matches('.template-product.template-suffix-rings'))return;
  const bar=document.querySelector('sticky-atc');
  if(!bar)return;
  const update=()=>document.body.style.setProperty('--fenno-sticky-atc-height',bar.getBoundingClientRect().height+'px');
  update();
  new ResizeObserver(update).observe(bar);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fennoSyncStickyHeight,{once:true});
else fennoSyncStickyHeight();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fenno-vitals-size"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const button=event.target.closest('[data-fenno-known-size]');
  if(!button)return;
  const picker=button.closest('variant-picker');
  if(!picker)return;
  const input=Array.from(picker.querySelectorAll('input[type="radio"]')).find(el=>el.value.split(' ')[0]===button.dataset.fennoKnownSize);
  if(!input||input.disabled)return;
  input.click();
  button.closest('details').open=false;
});
  } catch(e) { console.error(e); }
})();

})();
